export const getNameInitials = (entity) => `${entity.surname[0]}${entity.name[0]}`;
